export default __webpack_public_path__ + "static/media/mobile3.ff2e7f37.png";